"use client";

import {
  LiveKitRoom,
  RoomAudioRenderer,
  StartAudio,
} from "@livekit/components-react";
import { Chat } from "@/components/chat";
import { useConnection } from "@/hooks/use-connection";
import { AgentProvider } from "@/hooks/use-agent";
import { useState, useEffect } from "react";
import { CustomVideoConference } from "./custom-video-conference";
import { usePlaygroundState } from "@/hooks/use-playground-state";
import {
  getQueryParam,
  decryptValue,
  getUrlBasedOnEnv,
} from "@/app/utility/utilities";
export function RoomComponent(props: any) {
  const { shouldConnect, wsUrl, token } = useConnection();
  const [isConfigVisible, setIsConfigVisible] = useState(false);
  const [isConfigVisibleLeft, setIsConfigVisibleLeft] = useState(true);
  const [sessionData, setSessionData] = useState(""); 
  const [voiceID, setVoiceID] = useState("");
  const pgState = usePlaygroundState();
  const fetchSessionData = async () => {
    const sessionId = getQueryParam("session_id");
    if (!sessionId) {
      console.error("Session ID not found in the URL.");
      return;
    }

    try {
      const response = await fetch(
        `${getUrlBasedOnEnv(decryptValue(getQueryParam("env")))}/voice-ai/get-session/session_id/${decryptValue(sessionId)}/study_id/${decryptValue(getQueryParam("study_id"))}`,
      );
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
      const data = await response.json();
      setSessionData(data.data.session_prompt_ai);
      pgState.pgState.instructions = data.data.session_prompt_ai;
      setVoiceID(data.data.voice_id);
    } catch (error) {
      console.error("Failed to fetch session data:", error);
    }
  };

  // Call fetchSessionData on component mount
  useEffect(() => {
    fetchSessionData();
  }, []);

  return (
    <LiveKitRoom
      serverUrl={wsUrl}
      token={token}
      connect={shouldConnect}
      audio={true}
      video={props.isNewLayout ? true : false}
      className="flex-grow overflow-hidden border-l border-r border-b rounded-b-md"
      style={{ "--lk-bg": "white" } as React.CSSProperties}
    >
      <AgentProvider>
        {props.isNewLayout ? (
          <div className="grid grid-cols-1 xl:grid-cols-2 h-full">
            {/* Left side (VideoConference) */}
            <div className="flex items-center justify-center bg-gray-100 xl:border-r border-b xl:border-b-0 max-h-[50vh] xl:max-h-none h-full w-full">
              <div className="w-full h-full flex items-center justify-center">
                <CustomVideoConference
                  identity={decryptValue(getQueryParam("p_name"))}
                />
              </div>
            </div>
            {/* Right side (Chat) */}
            <div className="flex flex-col overflow-hidden">
              <div className="flex-grow flex flex-col justify-center w-full max-w-3xl mx-auto">
                {<props.Header isNewLayout={props.isNewLayout} />}
                <Chat
                  setIsConfigVisible={setIsConfigVisible}
                  isConfigVisible={isConfigVisible}
                  setIsConfigVisibleLeft={setIsConfigVisibleLeft}
                  isConfigVisibleLeft={isConfigVisibleLeft}
                  instructions={sessionData}
                  voiceID={voiceID}
                  session_id={decryptValue(getQueryParam("session_id"))}
                  isNewLayout={props.isNewLayout}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-1 h-full">
            <div className="h-full flex flex-col justify-center w-full mx-auto border-r">
              <Chat
                setIsConfigVisible={setIsConfigVisible}
                isConfigVisible={isConfigVisible}
                setIsConfigVisibleLeft={setIsConfigVisibleLeft}
                isConfigVisibleLeft={isConfigVisibleLeft}
                instructions={sessionData}
                voiceID={voiceID}
                session_id={decryptValue(getQueryParam("session_id"))}
                isNewLayout={props.isNewLayout}
              />
            </div>
          </div>
        )}
        <RoomAudioRenderer />
        <StartAudio label="Click to allow audio playback" />
      </AgentProvider>
    </LiveKitRoom>
  );
}
